<app-account-form [user]="user" (detailsEdit)="onDetailsEdit($event)" (passwordEdit)="onPasswordEdit($event)">
</app-account-form>